import { Tabs, TabsProps } from "antd";
import CompanyInvitationsV2 from "../invitation/CompanyInvitationsV2";
import CustomLabel from "../share/customLabel";
import { ColorPalette } from "../share/color/colorPalette";
import { useNavigate } from "react-router-dom";
import PersonelInvitationView from "../invitation/PersonelInvitationView";
import AcceleratorManagement from "../Notice/Accelerator/AcceleratorManagement";
import Positions2 from "../position/Positions2";
import MyInvitations from "../invitation/MyInvitations";
import Profile from "../Profiles/profile";
import ChangePassword from "../account/ChangePassword";
import ChangePassword2 from "../account/ChangePassword2";

const UserInfo = () => {
  const navigate = useNavigate();
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: " اطلاعات فردی   ",
      children: <Profile />,
    },
    {
      key: "2",
      label: "تغیر رمز",
      children: <ChangePassword2 />,
    },
    {
      key: "4",
      label: "دعوتنامه های من",
      children: <MyInvitations />,
    },
  ];
  const onChange = (key: string) => {
    navigate(`/UserInfo?tab=${key}`);
  };

  return (
    <>
      <Tabs
        style={{ fontFamily: "YekanBakhVF" }}
        tabBarStyle={{ marginBottom: 1 }}
        defaultActiveKey="1"
        items={items}
        onChange={onChange}
      />
    </>
  );
};
export default UserInfo;
